import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import {
  GrantState,
  OrgGrant,
  Provider,
} from '../../../api-clients/oem-connection';
import { OemIntegrationService } from '../../../services/oem-integration.service';

/**
 * Deere-only per-org grants panel (D9 / SRA003-126).
 * CNH never renders this — the parent ManageView is responsible for gating.
 */
@Component({
    selector: 'app-per-org-grants-panel',
    templateUrl: './per-org-grants-panel.component.html',
    styleUrls: ['./per-org-grants-panel.component.css'],
    standalone: false
})
export class PerOrgGrantsPanelComponent implements OnInit {
  @Input() provider!: Provider;

  loading = false;
  grants: OrgGrant[] = [];
  errorMessage = '';

  // Expose enums to template.
  readonly GrantState = GrantState;
  readonly Provider = Provider;

  constructor(
    private oemSvc: OemIntegrationService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    if (this.provider !== Provider.Deere) {
      // Defensive: parent should never instantiate us for CNH, but if
      // someone wires it wrong we just no-op rather than firing the call.
      return;
    }
    this.load();
  }

  load(): void {
    this.loading = true;
    this.errorMessage = '';
    this.oemSvc.listDeereGrants().subscribe({
      next: (grants) => {
        this.grants = grants ?? [];
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Could not load Deere organisation grants';
        this.loading = false;
      },
    });
  }

  grant(orgId: string): void {
    this.oemSvc.startDeereGrant(orgId).subscribe({
      error: () => {
        this.toastr.error('Could not start Deere data-access grant flow');
      },
    });
  }

  isPending(g: OrgGrant): boolean {
    return g.grant_status === GrantState.Pending;
  }

  isGranted(g: OrgGrant): boolean {
    return g.grant_status === GrantState.Granted;
  }

  isRevoked(g: OrgGrant): boolean {
    return g.grant_status === GrantState.Revoked;
  }

  chipLabel(g: OrgGrant): string {
    if (this.isGranted(g)) return 'Granted';
    if (this.isPending(g)) return 'Pending';
    return 'Revoked';
  }
}
